import unescapedText from 'I18n/utils/unescapedText';
import UIButton from 'UIComponents/button/UIButton';
import { Image } from 'foundations-components/transitional/components/Image';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { getThemeEventSelectorId } from '../../utils/hsAnalytics';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ThemeClientExamples({
  clientExamples,
  onTrackInteraction
}) {
  return /*#__PURE__*/_jsx(Grid, {
    rowGap: '200',
    children: clientExamples.map(({
      clientUrl,
      imageUrl
    }, index) => /*#__PURE__*/_jsx(GridItem, {
      size: {
        xs: 12,
        md: 4
      },
      children: /*#__PURE__*/_jsx(UIButton, {
        "data-hs-analytics-id": getThemeEventSelectorId('CLIENT-EXAMPLE'),
        external: true,
        href: clientUrl,
        iconProps: {
          className: 'hidden'
        },
        onClick: () => onTrackInteraction('click client example', {
          section: 'client examples',
          itemIndex: index
        }),
        use: "unstyled",
        children: /*#__PURE__*/_jsx(Image, {
          alt: unescapedText('marketplace-assets-ui.themes.details.clientExamples.imageAlt', {
            index
          }),
          src: imageUrl
        })
      })
    }, `client-example-${index}`))
  });
}